import { AccessTime } from "@mui/icons-material";
import React, { memo } from "react";

import { NodeCard, NodeHandle } from "./nodeKit";

export default memo(({ data, isConnectable, id }) => {
  return (
    <NodeCard color="#d97706" icon={<AccessTime />} title="Intervalo" id={id}>
      <NodeHandle type="target" isConnectable={isConnectable} />
      {data.sec} segundos
      <NodeHandle type="source" id="a" isConnectable={isConnectable} />
    </NodeCard>
  );
});
